module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/options/form.js
// module id = 486
// module chunks = 2